import httpClient from "Api/httpClient";

const END_POINT = "/me";

const updateSupervisorPin = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.patch(END_POINT + "/pin", payload);
};

export { updateSupervisorPin };
